import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from "moment/moment";
import TimeRange from "../../utils/TimeRange";
import StaticFunctions from "../../utils/StaticFunctions";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import PDFDownloadButton from "../../utils/PDFDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import LocationSelector from "../../globalComponents/LocationSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import TableContainer from "../../utils/TableContainer";
import MachineStates from "../../utils/MachineStates";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import CheckBoxField from "../../utils/CheckBoxField";
import domtoimage from "dom-to-image";

class ReportMachineSummary extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            showSubThreadbreaks: false,
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedMachine: null,//{value: 'all', label: this.translate('all')},
            selectedShift: null,
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            reportData: null,
            tableData: null,
            errorData: null,
            pdfChartUrls: null
        };

        this.reportKey = 'machineSummary';

        this.requestReport = this.requestReport.bind(this);
        this.requestPdfContent = this.requestPdfContent.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
        this.getPdfContent = this.getPdfContent.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) newState.selectedMachine = JSON.parse(machine);

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        // ShowSubThreadbreaks aus den userprops laden
        const showSubThreadbreaks = this.getReportSetting('showSubThreadbreaks', false);

        if (showSubThreadbreaks) newState.showSubThreadbreaks = true;

        if (newState) {
            this.setState(newState);
        }

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    selectedLocationId: 0,
                    selectedLocationName: 'all',
                    selectedMachine: null,
                    selectedShift: null,
                    reportData: null,
                    tableData: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;
        const machineIds = (machineId === 'all' && locationId) ? this.props.machines.getAllMachineIdsFromLocation(locationId) : [machineId];

        // Check, if all data is set
        if (!dateFrom || !dateTill || locationId === null || !machineId) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            companyId: this.props.baseData.companies.currentCompany.id,
            locationId: locationId,
            machineIds: machineIds,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                this.setState({
                    reportStatus: 'ready',
                    reportData: res.reportData,
                    tableData: res.tableData,
                    errorData: null,
                }, () => {
                    this.requestPdfContent();
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    reportData: null,
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            reportData: null,
            tableData: null,
            errorData: null,
            pdfChartUrls: null,
        }, () => {
            this.api.request('ReportMachineSummary', params, callback, error);
        });

    }

    requestPdfContent() {

        const domElement = document.getElementById('headline');

        if (domElement) {
            window.setTimeout(() => {
                domtoimage.toPng(domElement).then(function (dataUrl) {
                    this.setState({
                        pdfChartUrls: dataUrl
                    });
                }.bind(this))
            }, 1000);
        }

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        const allMachines = {value: 'all', label: this.translate('all')};

        this.setState({
            selectedLocationId: location ? parseInt(location.id) : 0,
            selectedLocationName: location ? location.name : '',
            selectedMachine: allMachines
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
            this.machineSelected(allMachines);
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: ((machine) ? JSON.stringify(machine) : null)});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state);

        // Safe option to Userconfig
        if (this.saveSettings && isChecked !== null) {
            this.saveSettings('reports', {report: this.reportKey, key: fieldName, value: isChecked});
        }

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
        } else if (this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (this.state.reportParams.selectedDesign === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.reportData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.reportData && this.state.reportData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
            locationTitle: this.translate('location'),
            allLocationsTitle: this.translate('allLocations'),
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getTableHeader() {

        const headline = this.getChartHeadline(this.state.reportParams.timeRange);

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange));
            csvContent.csvColumns.push(this.getCsvTableColumns());
            csvContent.csvData.push(this.getCsvTableRows());
        }

        return csvContent;

    }

    getPdfContent() {

        return {
            charts: (this.state.pdfChartUrls) ? [this.state.pdfChartUrls] : null,
            orientation: 'L',
            tableColumns: this.getTableColumns(),
            tableRows: this.getTableRows(),
            calculation: this.getPdfCalculation()
        };

    }

    getPdfCalculation() {

        const data = this.calculateReportData();
        const calculation = [];

        if (data) {
            calculation.push({
                A: this.translate('totalStitches'),
                B: StaticFunctions.formatedNumber((data.stitches > 0) ? data.stitches : 0),
                C: this.translate('stitchTime'),
                D: StaticFunctions.convertSecondsToFormatedString((data.stitchTime > 0) ? data.stitchTime : 0)
            });

            calculation.push({
                A: this.translate('totalThreadbreaks'),
                B: StaticFunctions.formatedNumber((data.threadbreaks > 0) ? data.threadbreaks : 0),
                C: this.translate('threadbreakTime'),
                D: StaticFunctions.convertSecondsToFormatedString((data.threadbreakTime > 0) ? data.threadbreakTime : 0)
            });

            calculation.push({
                A: this.translate('passings'),
                B: StaticFunctions.formatedNumber((data.passings > 0) ? data.passings : 0),
                C: this.translate('setupTime'),
                D: StaticFunctions.convertSecondsToFormatedString((data.setupTime > 0) ? data.setupTime : 0)
            });

            calculation.push({
                A: this.translate('numberOfPieces'),
                B: StaticFunctions.formatedNumber((data.pieces > 0) ? data.pieces : 0),
                C: this.translate('productionTime'),
                D: StaticFunctions.convertSecondsToFormatedString((data.productionTime > 0) ? data.productionTime : 0)
            });

            calculation.push({
                A: this.translate('stitchesPerMin'),
                B: StaticFunctions.formatedNumber((data.stitchesPerMin > 0) ? data.stitchesPerMin : 0, 2),
                C: this.translate('operatorBreaks'),
                D: StaticFunctions.convertSecondsToFormatedString((data.operatorBreaks > 0) ? data.operatorBreaks : 0)
            });

            calculation.push({
                A: this.translate('utilization'),
                B: StaticFunctions.formatedNumber((data.utilization > 0) ? data.utilization : 0, 2) + ' %',
                C: this.translate('downTime'),
                D: StaticFunctions.convertSecondsToFormatedString((data.downTime > 0) ? data.downTime : 0)
            });

            calculation.push({
                A: ' ',
                B: ' ',
                C: this.translate('totalTime'),
                D: StaticFunctions.convertSecondsToFormatedString((data.totalTime > 0) ? data.totalTime : 0)
            });
        }

        return calculation;

    }

    getCsvTableColumns() {

        return [
            {key: 'A', name: ' '},
            {key: 'B', name: ' '},
            {key: 'C', name: ' '},
            {key: 'D', name: ' '},
            {key: 'E', name: ' '},
            {key: 'F', name: ' '},
            {key: 'G', name: ' '},
            {key: 'H', name: ' '}
        ];

    }

    getCsvTableRows() {

        const reportData = this.calculateReportData();
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();
        const csvData = [];

        if (reportData) {
            csvData.push({
                A: this.translate('totalStitches'),
                B: StaticFunctions.formatedNumber(reportData.stitches),
                C: ' ',
                D: this.translate('stitchTime'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.stitchTime),
                F: ' ',
                G: ' ',
                H: ' '
            });

            csvData.push({
                A: this.translate('totalThreadbreaks'),
                B: StaticFunctions.formatedNumber(reportData.threadbreaks),
                C: ' ',
                D: this.translate('threadbreakTime'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.threadbreakTime),
                F: ' ',
                G: ' ',
                H: ' '
            });

            csvData.push({
                A: this.translate('passings'),
                B: StaticFunctions.formatedNumber(reportData.passings),
                C: ' ',
                D: this.translate('setupTime'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.setupTime),
                F: ' ',
                G: ' ',
                H: ' '
            });

            csvData.push({
                A: this.translate('numberOfPieces'),
                B: StaticFunctions.formatedNumber(reportData.pieces),
                C: ' ',
                D: this.translate('productionTime'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.productionTime),
                F: ' ',
                G: ' ',
                H: ' '
            });

            csvData.push({
                A: this.translate('stitchesPerMin'),
                B: StaticFunctions.formatedNumber(reportData.stitchesPerMin, 2),
                C: ' ',
                D: this.translate('operatorBreaks'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.operatorBreaks),
                F: ' ',
                G: ' ',
                H: ' '
            });

            csvData.push({
                A: this.translate('utilization'),
                B: StaticFunctions.formatedNumber(reportData.utilization, 2) + ' %',
                C: ' ',
                D: this.translate('downTime'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.downTime),
                F: ' ',
                G: ' ',
                H: ' '
            });

            csvData.push({
                A: ' ',
                B: ' ',
                C: ' ',
                D: this.translate('totalTime'),
                E: StaticFunctions.convertSecondsToFormatedString(reportData.totalTime),
                F: ' ',
                G: ' ',
                H: ' '
            });
        }

        if (tableColumns && tableRows) {
            csvData.push({A: ' ', B: ' ', C: ' ', D: ' ', E: ' ', F: ' ', G: ' ', H: ' '});
            csvData.push({A: ' ', B: ' ', C: ' ', D: ' ', E: ' ', F: ' ', G: ' ', H: ' '});

            const tableColumnLabels = tableColumns.forEach(
                (column) => {
                    return column.nameKey
                }
            );

            csvData.push({
                A: this.translate('machineId'),
                B: this.translate('machineName'),
                C: this.translate('onlineTime'),
                D: this.translate('stitches'),
                E: this.translate('threadbreaks'),
                F: this.translate('threadBreaksPer10KStiches'),
                G: this.translate('stitchesPerHour'),
                H: this.translate('utilization'),
            });

            tableRows.forEach(
                (row) => {
                    csvData.push({
                        A: row.machineId,
                        B: row.machineName,
                        C: row.onlineTime,
                        D: row.stitches,
                        E: row.threadbreaks,
                        F: row.threadBreaksPer10KStiches,
                        G: row.stitchesPerHour,
                        H: row.utilization
                    });
                }
            );
        }

        return csvData;

    }

    getTableColumns() {

        return [
            {
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'machineName',
                nameKey: 'machineName',
                sortType: 'string',
            },
            {
                key: 'onlineTime',
                nameKey: 'onlineTime',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'stitches',
                nameKey: 'stitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'threadbreaks',
                nameKey: 'threadbreaks',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'threadBreaksPer10KStiches',
                nameKey: 'threadBreaksPer10KStiches',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'stitchesPerHour',
                nameKey: 'stitchesPerHour',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'utilization',
                nameKey: 'utilization',
                classes: 'text-right',
                sortType: 'int',
            },
        ];

    }

    getTableRows() {

        const data = this.state.tableData;
        const rows = [];

        if (data) {
            for (let i = 0; i < data.length; i++) {
                let rowTemp = data[i];
                let machineDetails = this.props.machines.getMachineByMachineId(rowTemp.machineId);
                let machineTimes = this.getMachineTimesById(rowTemp.machineId);
                let totalTimeTemp = MachineStates.calculateTotalTime(machineTimes, 's');
                let productionTimeTemp = MachineStates.calculateProductionTime(machineTimes, 's');
                let stitchesPerHour = (rowTemp.stitches > 0 && totalTimeTemp > 0) ? rowTemp.stitches / (totalTimeTemp / 60 / 60) : 0;
                let utilization = 0;

                if (totalTimeTemp > 0 && productionTimeTemp > 0) utilization = (100 / totalTimeTemp) * productionTimeTemp;

                rows.push({
                    id: i,
                    machineId: rowTemp.machineId,
                    machineName: machineDetails.alias,
                    onlineTime: StaticFunctions.convertSecondsToFormatedString(totalTimeTemp),
                    stitches: StaticFunctions.formatedNumber(rowTemp.stitches),
                    threadbreaks: StaticFunctions.formatedNumber(rowTemp.threadbreaks),
                    threadBreaksPer10KStiches: StaticFunctions.calcThreadbreaksByRatio(rowTemp.stitches, rowTemp.threadbreaks).replace('.', ','),
                    stitchesPerHour: StaticFunctions.formatedNumber(stitchesPerHour, 2),
                    utilization: StaticFunctions.formatedNumber(utilization, 2) + ' %'
                });
            }
        }

        return rows;

    }

    getMachineTimesById(machineId) {

        if (!machineId) return 0;

        const reportData = this.state.reportData.find(
            (data) => {
                return (data.machineId === machineId);
            }
        );

        return (reportData) ? reportData.status : 0;

    }

    calculateReportData() {

        const calculatedData = {
            stitches: 0,
            threadbreaks: 0,
            passings: 0,
            pieces: 0,
            stitchesPerMin: 0,
            entirePastTime: 0,
            utilization: 0,
            stitchTime: 0,
            threadbreakTime: 0,
            setupTime: 0,
            productionTime: 0,
            operatorBreaks: 0,
            downTime: 0,
            totalTime: 0,
        };

        //if (!this.state.reportData || this.state.reportData.selectedLocation === null || !this.state.reportData.selectedMachine) return calculatedData;
        if (this.state.reportStatus !== 'ready' || !this.state.reportData) return calculatedData;

        const reportData = this.state.reportData;
        const tableData = this.state.tableData;

        if (reportData) {
            reportData.forEach(
                (data) => {
                    let machineId = data.machineId;
                    let passes = (data.hasOwnProperty('passes')) ? parseInt(data.passes) : null;
                    let pieces = (data.hasOwnProperty('pieces')) ? parseInt(data.pieces) : null;
                    let status = data.status;
                    let machineStAndTb = StaticFunctions.findObjectInArray(tableData, 'machineId', machineId);

                    if (machineStAndTb) {
                        calculatedData.stitches += parseInt(machineStAndTb.stitches);
                        calculatedData.threadbreaks += parseInt(machineStAndTb.threadbreaks);
                    }

                    if (passes !== null) calculatedData.passings = passes;
                    if (pieces !== null) calculatedData.pieces = pieces;

                    if (status && status.length > 0) {
                        calculatedData.stitchTime += MachineStates.calculateStitchTime(status, 's');
                        calculatedData.threadbreakTime += MachineStates.calculateThreadbreakTime(status, 's');
                        calculatedData.setupTime += MachineStates.calculateSetupTime(status, 's');
                        calculatedData.productionTime += MachineStates.calculateProductionTime(status, 's');
                        calculatedData.operatorBreaks += MachineStates.calculateBreakTime(status, 's');
                        calculatedData.downTime += MachineStates.calculateDownTime(status, 's');
                        calculatedData.totalTime += MachineStates.calculateTotalTime(status, 's');
                    }
                }
            );
        }

        if (calculatedData.totalTime > 0 && calculatedData.productionTime > 0) calculatedData.utilization = (100 / calculatedData.totalTime) * calculatedData.productionTime;
        if (calculatedData.stitches > 0 && calculatedData.totalTime > 0) calculatedData.stitchesPerMin = (calculatedData.stitches / (calculatedData.totalTime / 60));

        return calculatedData;

    }

    renderStatusBlock(statusData) {

        if (!statusData) return null;

        let statusBlock = [];

        for (let statusCode in statusData) {
            let status = statusData[statusCode];
            let formatedPastTime = StaticFunctions.convertSecondsToFormatedString(status.pastTime / 1000);

            statusBlock.push(
                <tr key={statusCode}>
                    <td className="text-left labelSpan">{this.translate(statusCode)}</td>

                    <td className="text-left">
                        <input
                            name={statusCode}
                            type="text"
                            value={formatedPastTime}
                            disabled={true}
                        />
                    </td>
                </tr>
            );
        }

        return (
            <div className="formRow clearfix">
                <div className="col-sm-4">
                    <div className="ma-bo-10">
                        <table>
                            <tbody>
                                {statusBlock}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                    <div><button className="disabled-link">{this.translate('pdfDownloadLabel') + ' (PDF)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();
            const pdfContent = this.getPdfContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />

                    <PDFDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        charts={pdfContent.charts}
                        tableColumns={pdfContent.tableColumns}
                        tableRows={pdfContent.tableRows}
                        calculation={pdfContent.calculation}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const headline = this.getChartHeadline(this.state.reportParams.timeRange);
        const reportData = this.calculateReportData();
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div>
                <nav id="headline">
                    <h1>{headline}</h1>
                </nav>

                <div className="formSettings">
                    <div className="formRow clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('totalStitches')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="totalStitches"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.stitches)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('totalThreadbreaks')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="totalThreadbreaks"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.threadbreaks)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('passings')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="passings"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.passings)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('numberOfPieces')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="numberOfPieces"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.pieces)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('stitchesPerMin')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="stitchesPerMin"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.stitchesPerMin, 2)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('utilization')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="utilization"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.utilization, 2) + ' %'}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('stitchTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="stitchTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.stitchTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('threadbreakTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="threadbreakTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.threadbreakTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('setupTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="setupTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.setupTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('productionTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="productionTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.productionTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('operatorBreaks')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="operatorBreaks"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.operatorBreaks)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('downTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="downTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.downTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('totalTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="totalTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.totalTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ma-bo-10">
                    <TableContainer
                        baseData={this.props.baseData}
                        columns={tableColumns}
                        rows={tableRows}
                    />
                </div>
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const machineOptions = this.props.machines;

        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={machineOptions}
                                        currentMachine={this.state.selectedMachine}
                                        currentLocation={this.state.selectedLocationId}
                                        translate={this.translate}
                                        addAllOption={true}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>

                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('options')}</h4>

                                <div className="formBox">
                                    <CheckBoxField
                                        name="showSubThreadbreaks"
                                        label={this.translate('showSubThreadbreaks')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportMachineSummary;
